import { ExternalLink } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Button } from '@/components/ui/button'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import type { ProcessingPipelineState } from '@/services/api/adminProcessing'
import { Stat } from './Stat'

export function QueueCard({ pipeline }: { pipeline: ProcessingPipelineState }) {
  const { t } = useTranslation()
  const q = pipeline.queue
  return (
    <Card>
      <CardHeader className="flex flex-row items-start justify-between max-md:gap-3">
        <div className="max-md:min-w-0">
          <CardTitle className="text-base">{t('admin.processing.queue.title')}</CardTitle>
          <CardDescription className="max-md:break-all">
            {q?.queue ?? pipeline.health.queue}
          </CardDescription>
        </div>
        {q?.mgmt_url && (
          <Button variant="outline" size="sm" asChild>
            <a href={q.mgmt_url} target="_blank" rel="noreferrer">
              {t('common.open')} <ExternalLink className="ml-1 h-3 w-3" />
            </a>
          </Button>
        )}
      </CardHeader>
      <CardContent>
        {q ? (
          <div className="grid grid-cols-2 gap-3 md:grid-cols-5">
            <Stat label={t('admin.processing.queue.ready')} value={q.ready.toLocaleString()} />
            <Stat label={t('admin.processing.queue.unacked')} value={q.unacked.toLocaleString()} />
            <Stat
              label={t('admin.processing.queue.consumers')}
              value={q.consumers.toLocaleString()}
            />
            <Stat label={t('admin.processing.queue.inPerSec')} value={q.publish_rate.toFixed(2)} />
            <Stat label={t('admin.processing.queue.outPerSec')} value={q.deliver_rate.toFixed(2)} />
          </div>
        ) : (
          <div className="text-sm text-muted-foreground">
            {t('admin.processing.queue.unreachable')}
          </div>
        )}
      </CardContent>
    </Card>
  )
}
